<template>
  <div class="dast-banner-top">
    <div class="dast-banner-content">
      <span class="dast-banner-text">
        <span class="opacity-80">Brand new DAST:</span>
        Test your mobile app in runtime
        <span class="opacity-80">like never before</span>
      </span>
      <a :href="dastScanRoute" class="dast-banner-link" target="_blank" rel="noopener noreferrer">
        Request a DAST scan →
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DastBanner',
  computed: {
    dastScanRoute() {
      const DAST_LANDING_URL =
        'https://dast.oversecured.com/?utm_source=website&utm_medium=banner&utm_campaign=dast&utm_content=sa';

      return DAST_LANDING_URL;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/css/variables';

.dast-banner-top {
  width: 100%;
  height: $dast-banner-height;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    90deg,
    color(display-p3 0 0.2 0.7) 0%,
    color(display-p3 0.1 0.4 1) 100%
  );
}

.dast-banner-content {
  display: flex;
  align-items: center;
  color: white;
  font-size: 14px;
  font-weight: 600;
  padding: 0 8px;
  overflow: hidden;

  @media (min-width: 768px) {
    font-size: 16px;
    padding: 0 16px;
  }
}

.dast-banner-text {
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: 6px;
  flex-shrink: 0;

  .opacity-80 {
    opacity: 0.8;
  }
}

.dast-banner-link {
  margin-left: 16px;
  color: white;
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
  transition: opacity 0.2s ease-in-out;
  font-weight: 600;

  @media (min-width: 768px) {
    margin-left: 48px;
  }

  @media (max-width: 500px) {
    margin-left: 0;
  }

  &:hover {
    opacity: 0.8;
  }
}

@media (max-width: 500px) {
  .dast-banner-text {
    display: none;
  }
}
</style>
